// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"49c2dc1c","513":"69ef546b","703":"b64043f7","787":"c6006e9a"}[chunkId] + ".chunk.js";
};